import { render } from "./IMIVVitaminTherapiesContentEs.vue?vue&type=template&id=3e3336aa&scoped=true"
import script from "./IMIVVitaminTherapiesContentEs.vue?vue&type=script&lang=js"
export * from "./IMIVVitaminTherapiesContentEs.vue?vue&type=script&lang=js"

import "./IMIVVitaminTherapiesContentEs.vue?vue&type=style&index=0&id=3e3336aa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e3336aa"]])

export default __exports__